export interface EmailValidation {
  ok: boolean;
  reason?: "empty" | "format" | "too-long";
}

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const MAX_EMAIL_LENGTH = 254;

export function validateEmail(raw: string): EmailValidation {
  const email = raw.trim();
  if (!email) return { ok: false, reason: "empty" };
  if (!EMAIL_RE.test(email)) return { ok: false, reason: "format" };
  if (email.length > MAX_EMAIL_LENGTH) return { ok: false, reason: "too-long" };
  return { ok: true };
}
